import { createContext } from "react"

interface AuthorizationHeader {
	Authorization: string
}

export interface RequestContextProps {
	environment: "K" | "PP" | "P" | null
	getAuthorizationHeader: () => Promise<AuthorizationHeader>
}

export const initialRequestContext: RequestContextProps = {
	environment: null,
	// eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
	getAuthorizationHeader: () => Promise.reject(),
}

export const RequestContext = createContext<RequestContextProps>(initialRequestContext)
